import ReportsPage from "../view/ReportsPage.vue";

export default [
    {
        path: "/Reports",
        name: "Reports",
        component: ReportsPage,
        meta: { requiresAuth: true, checkPermissions: true, module: "reports", title: "CruzControl | Reports" }
    },
    {
        path: "/Reports/Site_Command/washed/:subPage",
        name: "Washed Report",
        component: ReportsPage,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "reports",
          feature: "washed",
          title: (route) => {
            const map = {
              summary: "Washed Summary Report",
              hourly: "Washed Hourly Report",
              daily: "Washed Daily Report",
              day_of_week: "Washed Day Of Week Report",
            }

            return map[route.params.subPage] ? `CruzControl | ${map[route.params.subPage]}` : null;
          }
        }
    },
    {
        path: "/Reports/Site_Track/Assets/:subPage",
        name: "AssetsReport",
        component: ReportsPage,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "reports",
          feature: "assets",
          title: (route) => {
            const map = {
              cost_of_ownership: "Assets Report",
              detailed_cost_of_ownership: "Assets With Work Orders",
            }

            return map[route.params.subPage] ? `CruzControl | ${map[route.params.subPage]}` : null;
          }
        }
    },
    {
        path: "/Reports/Site_Track/pm_audits/:subPage",
        name: "PreventiveMaintenanceReport",
        component: ReportsPage,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "reports",
          feature: "pm_audits",
          title: (route) => {
            const map = {
              pm_audit_report: "PM Audit Report",
              pm_completion: "PM Completion Report",
            }

            return `CruzControl | ${map[route.params.subPage] ?? "PM Audits"}`
          }
        }
    },
    {
        path: "/Reports/Site_Scan/Chem/:subPage",
        name: "Chem",
        component: ReportsPage,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "reports",
          feature: "chemical",
          title: (route) => {
            const map = {
              chemical_status: "Chemical Status Report",
              product_consumption: "Product Consumption Report",
              package_consumption: "Package Consumption Report",
            }

            return map[route.params.subPage] ? `CruzControl | ${map[route.params.subPage]}` : null;
          }
        }
    },
    {
        path: "/Reports/Site_Track/Inventory/inventory_state_report",
        name: "Inventory Management",
        component: ReportsPage,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "reports",
          feature: "inventory",
          title: "CruzControl | Current Inventory Report",
        }
    },
    {
        path: "/Reports/Site_Track/PurchaseOrders/purchase_orders",
        name: "Purchase Orders",
        component: ReportsPage,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "reports",
          feature: "purchase_orders",
          title: "CruzControl | Purchase Orders Report",
        }
    },
    {
      path: "/Reports/Washlink/:subPage",
      name: "Washlink",
      component: ReportsPage,
      meta: {
        requiresAuth: true,
        checkPermissions: true,
        module: "reports",
        feature: "washlink",
        title: "CruzControl | Revenue Breakdown Report",
      }
  }
]